<template>
    <v-sheet v-if="showGraphs" :class="xs?'card-dialogs-graph-wop':'card-dialogs-graph'" class="ma-4 pb-0" color="bgtopology">
        <v-row class="ma-0" v-if="finalTOTArray.length !== 0">
            <v-col cols="12" class="pa-0 pr-2" align-self="center">
                <v-sheet color="transparent" class="text-center">
                    <SingleChart :name="STRING_GENERAL.Status" :first-array="finalTOTArray" :title=" t('title.statuLog')" color="#0E2F5A"/>                 
                </v-sheet>
            </v-col>
        </v-row>
        <v-sheet v-else class="text-center" color="transparent">
            <Prog_circular />
        </v-sheet>
    </v-sheet>
        
</template>

<script setup lang="ts">
import { Ref, onMounted, ref } from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n }  from 'vue-i18n';
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
import { useStore }   from 'vuex';
const store  = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
import Prog_circular    from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleChart      from '@/components/SmartLink/charts/SingleChart.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { STRING_GENERAL }     from '@/constants/labels';
import { LABELS } from '@/constants/labels';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getStatusLogByIP } from '@/services/Smartlink/Graphs';

const props = defineProps({
    ip          : { required:true, type:String },
    typesel     : { required:true, type:String },
    name        : { required:true, type:String },
})


const finalTOTArray:Ref<number[][]> = ref([]);

/**
 * 
 */
const showGraphs                     = ref(true);

const params = { ip : props.ip };


/**
 * Captura los valores de la API: 'getStatusLogGraph'
 */
const getData = async () =>{

    const allData = await getStatusLogByIP(params)
    
    if( allData.status === 400 ){
        showGraphs.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showGraphs.value = allData.showGraphs
        finalTOTArray.value = allData.data
    }
    
}

onMounted( async() => {
    getData();
})

</script>